import type { Resource } from '../../';
export const country_countries_RE: Resource = {"default":"Réunion"};
